import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import "./homepage.css"
import Menu from '../Menu/Menu';
import OffCanvas from '../OffCanvas/OffCanvas';
import ProfileNav from '../ProfileNav/ProfileNav';
import Fade from '@mui/material/Fade';
import Loader from '../Loader/Loader';
import mainContext from '../../contexts/mainContext';

const HomePage = (props) => {
    const { loginUserDetails, setLoginUserDetails } = props;
    const { pageload } = React.useContext(mainContext);

    return (
        <>
            <Fade in={true} >
                <div className="nona_admin_main_div">
                    <OffCanvas />
                    <Menu loginUserDetails={loginUserDetails} setLoginUserDetails={setLoginUserDetails} />
                    <div className="detail_section">
                        <Loader type='fullpage' open={pageload} />
                        <ProfileNav />
                        <Outlet />
                    </div>
                </div>
            </Fade>
        </>
    )
}

export default HomePage